import React from 'react';
import { connect } from 'react-redux';

import { emailTemplatesConfig } from '../../entity/CMS/emailTemplatesConfig';
import MasterComponent from '../../components/Forms';

const EmailTemplates = () => {


  return <MasterComponent config={emailTemplatesConfig} />
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(EmailTemplates);